import { defineMessages } from "react-intl";

export default defineMessages({
  proceedToPayment: {
    id: "checkout.checkOrder.proceedToPayment",
    defaultMessage: "Proceed to payment",
  },
  checkYourOrder: {
    id: "checkout.checkOrder.checkYourOrder",
    defaultMessage: "Check your order.",
  },
  confirmCheckout: {
    id: "close.checkout.confirm",
    defaultMessage: "Confirm your checkout",
  },
  goBack: {
    id: "globals.goBack",
    defaultMessage: "Go back",
  },
  spOffer: {
    id: "serviceOfferOrderPreview.spOffer",
    defaultMessage: "{serviceProviderName}'s offer",
  },
  transferNotMade: {
    id: "serviceOfferOrderPreview.transferNotMade",
    defaultMessage: "Transfer not made",
  },
  transferErrorMessage: {
    id: "serviceOfferOrderPreview.transferErrorMessage",
    defaultMessage:
      "We are unable to pay the service provider because, unless we are mistaken, you have not yet made the payment of €66. You can make this payment by bank transfer:",
  },
});
